import { API_URLS } from "../constants";
import { postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const getSurveyReportForPOSAndOnlineStores = (body) => {
  return postRequest(
    API_URLS.USER_RESPONSES.GET_SURVEY_REPORT_FOR_POS_AND_ONLINE_STORES,
    body
  )
    .then((response) => responseHandler.handleServerResponse(response))
    .catch((error) => responseHandler.handleHTTPResponses(error.response));
};

export const brandReportService = {
  getSurveyReportForPOSAndOnlineStores,
};
